import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/auth/breadcrumbs/Breadcrumbs";
import { CONTACT } from "../../../api/Contact";

export default function ContactView() {
  let { id } = useParams();
  const [data, setData] = useState(null);
  const getAdmin = async (id) => {
    try {
      const res = await CONTACT.GET_BY_ID(id);
      // const res = await axios.get(`${CONSTANT.URL}admin/${id}`);
      if (res.status !== 200) {
        throw new Error("Failed to fetch brand information");
      }
      const request = {
        isViewed: true,
      };
      await updateEnquiry(request);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };
  useEffect(() => {
    getAdmin(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  const markAsUnRead = async () => {
    const request = {
      isViewed: false,
    };
    await updateEnquiry(request);
  };

  const updateEnquiry = async (data) => {
    try {
      const res = await CONTACT.UPDATE(data, id);
      if (res.status !== 200) {
        throw new Error("Failed to fetch brand information");
      }
      setData(res.data);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  return (
    <div>
      <Breadcrumbs pageName="Enquiry Details" />
      <div className=" rounded-md border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark flex justify-between">
          <h3 className="font-medium text-black dark:text-white">
            Enquiry Info
          </h3>
          {data !== null && data.isViewed && (
            <button
              onClick={() => {
                markAsUnRead();
              }}
            >
              Mark us Unread
            </button>
          )}
        </div>
        {data !== null ? (
          //   <div className="grid grid-cols-1 gap-9 sm:grid-cols-2 ">
          <div className="grid grid-cols-1 sm:grid-cols-2 pt-5">
            <div className="p-6.5 pt-0">
              <label className="mb-2.5 block text-black dark:text-white">
                Name
              </label>
              <div className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary">
                {data.name}
              </div>
            </div>
            <div className="p-6.5 pt-0">
              <label className="mb-2.5 block text-black dark:text-white">
                Place
              </label>
              <div className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary">
                {data.place}
              </div>
            </div>
            <div className="p-6.5 pt-0">
              <label className="mb-2.5 block text-black dark:text-white">
                Mobile No
              </label>
              <div className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary">
                {data.mobile}
              </div>
            </div>
            <div className="p-6.5 pt-0">
              <label className="mb-2.5 block text-black dark:text-white">
                Email
              </label>
              <div className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary">
                {data.email}
              </div>
            </div>
            <div className="p-6.5 pt-0">
              <label className="mb-2.5 block text-black dark:text-white">
                Message
              </label>
              <div className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary">
                {data.message}
              </div>
            </div>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
}
